import { useState } from "react";
import { ImcCalc } from "./imcCalc";

export const Calculadora = () => {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [gender, setGender] = useState(""); // <- Novo estado para gênero
  const [resultado, setResultado] = useState(null);

  const calcular = () => {
    if (!weight || !height || !gender) {
      setResultado("Preencha todos os campos!");
      return;
    }

    const { imc, classification } = ImcCalc({
      weight: Number(weight),
      height: Number(height),
      gender,
    });

    setResultado(`Seu IMC é ${imc} — ${classification}`);
  };

  return (
    <div className="imc-card">
      <div className="imc-inputs">

        <input
          type="number"
          placeholder="Altura (cm)"
          value={height}
          onChange={(e) => setHeight(e.target.value)}
        />

        <input
          type="number"
          placeholder="Peso (kg)"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
        />

        {/* NOVO CAMPO DE GÊNERO */}
        <div className="gender-box mt-2">
          <label>Gênero:</label>
          <select
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            className="form-select"
          >
            <option value="">Selecione...</option>
            <option value="masculino">M — Masculino</option>
            <option value="feminino">F — Feminino</option>
          </select>
        </div>

        <button onClick={calcular} className="btn btn-custom btn-lg mt-3">
          Calcular IMC
        </button>
      </div>

      {resultado && <p className="imc-result mt-3">{resultado}</p>}
    </div>
  );
};
